module.exports = __webpack_public_path__ + "static/image3-53283c5aa4ce0f722de8f1880fc46940.jpg";